import { loanType } from "../enum/kyc.enum";

const zi_configuration = {
  country_code: 'ZI',
  currency: 'Rp.',
  date_format: {
    date: 'dd MMMM yyyy',
    date_short: 'yyyy-MM-dd',
    date_short_moment: 'YYYY-MM-DD',
    date_short_dmy: 'dd/MM/yyyy',
    date_time: 'dd MMMM yyyy HH:mm:ss',
    date_time_not_second: 'yyyy-MM-dd HH:mm',
    locale: 'id',
  },
  number_format: {
    align: 'left',
    allowNegative: false,
    decimal: '.',
    precision: 2,
    prefix: 'Rp',
    suffix: '',
    thousands: ',',
    locale: 'id'
  },
  pipe: {
    precision: '1.2-2'
  },
  language: {
    default: 'en',
    show: true
  },
  loan: {
    underwriting: {
      guaranteeFee: {
        show: false
      }
    }
  },
  enable_pefindo: true,
  show_generate_instruction: true,
  primary_ic_type_id: 12, // KTP
  hide_blank_dropdown_options: {
    industry: false,
  },
  phoneValidation:{
    code:'+62',
    phoneNumberLengthWithCode:[12,13,14,15],
    phoneNumberLengthWithoutCode:[9,10,11,12]
  },
  show_user_type_column_in_facility_user: true,
  show_bca_va_reconciliation_upload: true,
  use_custom_investor_management_pagination: false,
  use_custom_borrower_management_pagination: false,
  use_custom_partner_management_pagination: false,
  add_doc_type_and_loan_code_to_loan_agreement_filename: false,
  defaultBranch: 'JKT',
  show_distribution_gst: false,
  show_risk_category_fields: true,
  enableSubscribeMainToProxyLoanDocTypes: true,
  inclusive_withholding_tax: false,
  has_usd_to_local_currency_conversion: false,
  kycSubstitution: {
    TERM_LOAN: loanType.TERM_LOAN,
    CREDIT_LINE: loanType.CREDIT_LINE,
    ONLY_PARTNERS: ['oto'],
    APPLICATION: 'Application',
    KYC: 'APF Paylater Micro KYC',
    BNPL: 'APF BNPL Micro',
    VCC: 'APF Paylater Micro',
  },
  showFacilityID: false,
  showLoanID: true,
  additionInfoTab: true,
  triggerMicroLoanService: false,
};

export default zi_configuration;
